import React, { useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import EsicPfdataTable from "./EsicPfdataTable";

const EsicPf = () => {
  const dispatch = useDispatch();
//   const {
//     data = [],
//     loading = false,
//     isModalOpen = false,
//   } = useSelector((state) => state.employeeData || {});

 
  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="ESIC & PF "
            title="Dashboard"
            subtitle="ESIC & PF"
            // name="Import Employee"
            // onAddClick={() => dispatch(openEmployeeModal())}
          />

          <EsicPfdataTable  />

        </div>
      </div>
    </div>
  );
};

export default EsicPf;
